<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="menuActiveName"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in menuList"  :menu="route" :key="route.url" :base-path="route.url" :dynamicMenuRoutes="dynamicMenuRoutes" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './main-sidebar-sub-menu'
import variables from '@/styles/variables.scss'
import { getRouteList } from '@/api/user'
export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      dynamicMenuRoutes: [],
      menuList:[
        
      ],
      menuActiveName:'',
      mainTabsActiveName:''
    }
  },
  // watch: {
  //   $route: "routeHandle",
  // },
  created() {
    // this.menuList = JSON.parse(sessionStorage.getItem("menuList") || "[]");
    // console.log(sessionStorage.getItem("menuList"));
    // this.dynamicMenuRoutes = JSON.parse(
    //   sessionStorage.getItem("dynamicMenuRoutes") || "[]"
    // );
    this._getRouteList();
    // this.routeHandle(this.$route);
    this.menuActiveName = this.$route.path
  },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar'
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    
  },
  methods: {
    // 路由操作
    // routeHandle(route) {
    //   if (route.meta.isTab) {
    //     console.log(route)
    //     // tab选中, 不存在先添加
    //     var tab = this.menuList.filter((item) => item.name === route.name)[0];
    //     if (!tab) {
    //       if (route.meta.isDynamic) {
    //         route = this.dynamicMenuRoutes.filter(
    //           (item) => item.name === route.name
    //         )[0];
    //         if (!route) {
    //           return console.error("未能找到可用标签页!");
    //         }
    //       }
    //       tab = {
    //         menuId: route.meta.menuId || route.name,
    //         name: route.name,
    //         title: route.meta.title,
    //         type: isURL(route.meta.iframeUrl) ? "iframe" : "module",
    //         iframeUrl: route.meta.iframeUrl || "",
    //         params: route.params,
    //         query: route.query,
    //       };
    //       this.mainTabs = this.mainTabs.concat(tab);
    //     }
        
    //     this.menuActiveName = route.path + "";
        
    //     this.mainTabsActiveName = route.path;
    //   }
    // },
    // 获取路由数据
    _getRouteList() {
      getRouteList().then(res => {
        if (res.code === 0) {
          // console.log(res.menuList)
          this.menuList = res.menuList
          // this.menuActiveName = res.menuList[0].url
        }
      })
    }
  },
}
</script>
